<template>
  <component
    :is="component"
    v-bind="linkAttributes"
    class="relative z-10 flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1.5 text-sm font-medium transition-colors lg:px-3.5"
    :class="
      item.active
        ? 'bg-white text-brand-600 dark:bg-zinc-800 dark:text-brand-400'
        : 'text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-200'
    "
  >
    <NavIcon
      v-if="item.icon"
      :name="item.icon"
      class="size-4 shrink-0"
      :class="
        item.active
          ? 'text-brand-600 dark:text-brand-400'
          : 'text-current'
      "
      width="16"
      height="16"
    />
    <span class="hidden lg:inline">{{ item.name }}</span>
  </component>
</template>

<script>
import identity from 'lodash/identity'
import isNull from 'lodash/isNull'
import omitBy from 'lodash/omitBy'
import pickBy from 'lodash/pickBy'
import NavIcon from './NavIcon.vue'

export default {
  components: {
    NavIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    requestMethod() {
      return this.item.method || 'GET'
    },

    component() {
      if (this.requestMethod !== 'GET') {
        return 'FormButton'
      }

      if (this.item.external !== true) {
        return 'Link'
      }

      return 'a'
    },

    linkAttributes() {
      const method = this.requestMethod

      return pickBy(
        omitBy(
          {
            href: this.item.path,
            method: method !== 'GET' ? method : null,
            headers: this.item.headers || null,
            data: this.item.data || null,
            rel: this.component === 'a' ? 'noreferrer noopener' : null,
            target: this.item.target || null,
          },
          isNull
        ),
        identity
      )
    },
  },
}
</script>
